<template>
  <div>
    

    <table>
      <tr>
        <td v-for="location in $locations" :key="location" valign="top">
          <h4>{{location}}</h4>
          <table>
            <tr><th>Name</th><th>Count</th></tr>
            <tbody v-if="filteredData.RCGB.topSales.length > 0">
              <tr v-for="d in filteredData[location].topSales" :key="d.ItemNum">
                <td>{{d.ItemName}}</td>
                <td>{{d.count}}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td>{{total[location].topSales.count}}</td>
              </tr>
            </tbody>
            <!-- Placeholder for empty data -->
            <tbody v-else>
              <tr v-for="index in qualifier.top" :key="index">
                <td>&nbsp;</td>
                <td>-</td>
              </tr>
            </tbody>
          </table> 
        </td>
      </tr>
    </table> 
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'TopSalesTable',
  props : ['value', 'timestamps', 'qualifier'],
  data () { return {
      categories: [],
      data: {
        RCGB: {topSales:[]},
        RMGB: {topSales:[]},
        WGB : {topSales:[]},
      },
      // q: {
      //   top: 25,
      //   subtypes : ['CONF'],
      //   notSubtypes : ['Gas', 'CIGS', 'POP'],
      // }
    }
  },
  created : async function(){
    await this.loadCategories();
    this._loadData();
  },
  watch: {
    'timestamps.from' : 'loadData',
    'timestamps.to' : 'loadData',
    'qualifier.top' : 'loadData',
    'qualifier.subtypes' : 'loadData',
    'qualifier.notSubtypes' : 'loadData',
  },
  computed : {
    isLoading: function(){
      let result = false;
      this.$locations.forEach(location => {
        const l = this.data[location]
        result = result || l.topSales.isLoading;
      })
      return result;
    }
  },
  methods: {
    loadCategories: async function(){
      // let r = await this.$axios.get(`/api/WGB/categories`)
      let r = await this.$axios.get(`/api/RMGB/categories`)
      this.categories = r.data;
      console.log(this.categories)
    },
    loadData: _.debounce(function(){
      this._loadData()
    }, 800),
    _loadData: function(){
      console.log('loading data')
      if(this.timestamps.from === undefined || this.timestamps.to === undefined){
        return;
      }
      
      //Strip timezone from ts 
      let from = moment(this.timestamps.from).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss");
      let to = moment(this.timestamps.to).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss");
      console.log('from to', from, to)
      
      this.$locations.forEach(location=>{
      // ['RMGB'].forEach(location=>{
        const getData = (endpoint, dataKey) => {
          this.data[location][dataKey] = [];
          this.data[location][dataKey].isLoading = true;
          const options = { location, from, to, ...this.qualifier}
          this.$axios.post(endpoint, options).then((r)=>{
            this.data[location][dataKey].isLoading = false;
            this.data[location][dataKey] = r.data.length > 0 ? r.data : this.data[location][dataKey]
            this.$emit('input', this.data)
          });
        }
        getData('/getTopSales', 'topSales')
      })
    },
  },
  computed: {
    total: function(){
      return this.$math.sumSubSubKeys(this.filteredData);
    },
    filteredData: function(){
      const q = this.qualifier
      if(q.includeFilter.length === 0 && q.excludeFilter.length === 0){
        return this.data
      } else {
        const result = {
          RCGB: {topSales:[]},
          RMGB: {topSales:[]},
          WGB : {topSales:[]},
        }
        this.$locations.forEach(location=>{
          result[location].topSales = this.data[location].topSales.filter(r=>{
            const itemName = r.ItemName.toLowerCase()
            const dept = r.Description.toLowerCase()
            const inFilter = q.includeFilter.toLowerCase()
            const exFilter = q.excludeFilter.toLowerCase()
            // return  (inFilter.length> 0 ? itemName.includes(inFilter) : true) && (exFilter.length> 0 ? !itemName.includes(exFilter) : true)
            
            const namefilter =  (inFilter.length> 0 ? itemName.includes(inFilter) : true) && (exFilter.length> 0 ? !itemName.includes(exFilter) : true)
            const deptFilter =  (inFilter.length> 0 ? dept.includes(inFilter) : true) && (exFilter.length> 0 ? !dept.includes(exFilter) : true)
            
            return this.qualifier.willFilterDepartment ?  deptFilter : namefilter;
            // return namefilter;

          })
        })
        return result;
      }

    }

  },
  filters: {
    
  }
}
</script>


<style scoped>

</style>

